export type PlanName = 'Free' | 'Pro' | 'Advanced'
export type BillingCycle = 'monthly' | 'yearly'

export interface PlanFeature {
  text: string
  included: boolean
}

export interface PlanDefinition {
  name: PlanName
  price: Record<BillingCycle, number>
  currency: '€'
  description: string
  features: PlanFeature[]
  cta: string
  highlight: boolean
}

export const planDefinitions: PlanDefinition[] = [
  {
    name: 'Free',
    price: { monthly: 0, yearly: 0 },
    currency: '€',
    description: 'For testing and evaluation',
    features: [
      { text: '3 PDF uploads per month', included: true },
      { text: '1 page processing per document', included: true },
      { text: '1 export per document', included: true },
      { text: 'Standard extraction', included: true },
      { text: 'Column selection', included: true },
      { text: 'Advanced OCR', included: false },
      { text: 'Batch upload', included: false },
      { text: 'Priority processing', included: false },
      { text: 'Split-screen viewer', included: false },
      { text: 'Team collaboration', included: false },
    ],
    cta: 'Get Started',
    highlight: false,
  },
  {
    name: 'Pro',
    price: { monthly: 25, yearly: 255 },
    currency: '€',
    description: 'For professionals processing documents weekly',
    features: [
      { text: 'Unlimited PDF uploads', included: true },
      { text: 'Unlimited page processing', included: true },
      { text: 'Unlimited exports', included: true },
      { text: 'Standard extraction', included: true },
      { text: 'Column selection', included: true },
      { text: '50 advanced OCR scans/month', included: true },
      { text: 'Batch upload', included: true },
      { text: 'Priority processing', included: true },
      { text: 'Split-screen viewer', included: false },
      { text: 'Team collaboration', included: false },
    ],
    cta: 'Upgrade to Pro',
    highlight: true,
  },
  {
    name: 'Advanced',
    price: { monthly: 49, yearly: 495 },
    currency: '€',
    description: 'For teams with advanced needs',
    features: [
      { text: 'Everything in Pro', included: true },
      { text: 'Unlimited advanced OCR scans', included: true },
      { text: 'Split-screen PDF viewer', included: true },
      { text: 'Table highlighting', included: true },
      { text: 'Team collaboration', included: true },
      { text: 'Document sharing', included: true },
      { text: 'API access', included: true },
      { text: 'Priority support', included: true },
    ],
    cta: 'Upgrade to Advanced',
    highlight: false,
  },
]
